<template>
  <div class="app-container">
    <el-form ref="form" label-position="left" label-width="120px" size="small" :model="form" :rules="rules">
      <el-form-item class="w500" prop="title" label="标题">
        <el-input v-model="form.title" placeholder="至少8个汉字" maxlength="40" show-word-limit></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item class="w500" prop="desc" label="描述">
            <el-input v-model="form.desc" maxlength="40" show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item class="w500" prop="cat_uuid" label="分类">
            <el-select v-model="form.cat_uuid" placeholder="请选择分类">
              <el-option v-for="(item, index) in classList" :key="index" :label="item.title" :value="item.uuid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item class="w1000" label="正文" prop="detail">
        <full-edit v-model="form.detail"></full-edit>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item class="w500 form-img" label="添加图片" prop="thumb">
            <imgUpload v-if="form.thumb.split(',').length < 3" @imgUrl="changeImg"></imgUpload>
            <div v-if="form.thumb" style="display: flex">
              <div v-for="(item, index) in form.thumb.split(',')" :key="index" style="margin-left: 30px" class="thumbs">
                <img style="width: 178px; height: 178px; object-fit: cover" :src="item" alt="" />
                <span @click="clones(index)">×</span>
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item class="w500" label="添加视频">
            <imgUploads v-model="form.vedio" source-type="1"></imgUploads>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="置顶状态" prop="isTop">
        <el-checkbox v-model="form.is_top" label="置顶" :true-label="2" :false-label="1"></el-checkbox>
      </el-form-item>
      <el-row>
        <el-col :span="6">
          <el-form-item label="是否定时发布" prop="regularRelease">
            <el-checkbox v-model="iftime" label="定时发布" @change="setTime"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col v-if="iftime" :span="12">
          <el-date-picker
            v-model="form.publish_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="发布日期"
          >
          </el-date-picker>
        </el-col>
      </el-row>
    </el-form>

    <div class="footer">
      <el-button type="primary" :loading="submitLoading" @click="formSubmit"> 确定 </el-button>
      <el-button @click="backList">取消</el-button>
    </div>
  </div>
</template>
<script>
import imgUpload from "@/components/pub/imgUploadNormal";
import imgUploads from "@/components/pub/supperUpload.vue";
import fullEdit from "@/components/pub/fulledit";
import { getCate, addArticle, actileDetail, editArticle } from "@/api/operation.js";
export default {
  components: {
    imgUpload,
    imgUploads,
    fullEdit,
  },
  data() {
    return {
      iftime: false,
      query: {},
      form: {
        thumb: "",
      },
      classList: [],
      submitLoading: false,
      rules: {
        title: [
          {
            required: true,
            message: "标题不能为空",
            trigger: "blur",
          },
          {
            min: 8,
            max: 40,
            message: "长度在 8 到 40 个字符",
            trigger: "blur",
          },
        ],
        desc: [
          {
            required: true,
            message: "描述不能为空",
            trigger: "blur",
          },
        ],
        cat_uuid: [
          {
            required: true,
            message: "请选择分类",
            trigger: "blur",
          },
        ],
        detail: [
          {
            required: true,
            message: "正文不能为空",
            trigger: "blur",
          },
        ],
        vedio: [
          {
            required: true,
            message: "视频不能为空",
            trigger: "change",
          },
        ],
        thumb: [
          {
            required: true,
            message: "图片不能为空",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    this.getClassList();
    this.query = this.$route.query;
    if (this.query.uuid) {
      this.getDetail();
    }
  },
  methods: {
    changeImg(e) {
      if (this.form["thumb"]) {
        this.form["thumb"] += "," + e;
      } else {
        this.form["thumb"] = e;
      }
      console.log(this.form, "---------");
    },
    clones(index) {
      const imgs = this.form.thumb.split(",");
      imgs.splice(index, 1);
      this.form.thumb = imgs.join(",");
    },
    getDetail() {
      actileDetail(this.query.uuid).then((res) => {
        if (res.uuid) {
          this.iftime = !!res.publish_time;
          this.form = { ...res, vedio: [res.vedio] };
        }
      });
    },
    setTime(val) {
      if (!val) {
        this.form.publish_time = "";
      }
    },
    getSchoolDetail() {
      // TODO : 获取学校风采详情
    },
    async getClassList() {
      const res = await getCate({ status: 2 });
      if (res.data instanceof Array) {
        this.classList = res.data;
      }
    },
    formSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const data = {
            ...this.form,
            type: 1,
            vedio: Array.isArray(this.form.vedio) ? this.form.vedio[0] : "",
          };
          if (!data.uuid) {
            this.submitLoading = true;

            addArticle(data).then((res) => {
              if (res === true) {
                this.$notify({
                  title: "操作成功",
                  type: "success",
                });
                this.submitLoading = false;
                this.backList();
              }
            });
          } else {
            this.submitLoading = true;

            editArticle(data, data.uuid).then((res) => {
              if (res === true) {
                this.$notify({
                  title: "操作成功",
                  type: "success",
                });
                this.submitLoading = false;
                this.backList();
              }
            });
            // TODO: 学校风采编辑接口对接
            // data.id = id;
            // await editMenu(id, data).catch(error => {
            //     this.submitLoading = false;
            //     throw error;
            // });
          }
        }
      });
    },
    backList() {
      this.$router.push({
        path: "/school-style",
      });
    },
  },
};
</script>
<style lang="less" scoped>
// /deep/.avatar-uploader{
//     width:178px !important;
// }
.thumbs {
  position: relative;
  span {
    cursor: pointer;
    display: block;
    position: absolute;
    right: -10px;
    top: -10px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    color: #fff;
    background-color: red;
  }
}
.form-img {
  /deep/ .el-form-item__content {
    display: flex;
  }
}
.w1000 {
  width: 1000px;
}

.w500 {
  width: 500px;
}

.w250 {
  width: 250px;
}
</style>
